import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach Bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("tcd_token");
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Global response handler:
//  - 401 → token bad/expired → force logout + redirect to /login
//  - 403 → permission denied → let the call reject but don't bubble as an
//    "unhandled rejection" so React's dev overlay stays quiet. Public invite
//    endpoints are exempt (their 404 is meaningful UI state).
// Routes that are publicly viewable — never auto-redirect to /login from here.
const PUBLIC_PATHS = ["/", "/login", "/invite"];
const isOnPublicRoute = () => {
  if (typeof window === "undefined") return false;
  const p = window.location.pathname;
  if (p === "/") return true;
  return PUBLIC_PATHS.some((r) => p === r || p.startsWith(r + "/"));
};

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (
      status === 401 &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/me") &&
      !isOnPublicRoute()
    ) {
      // Token expired or invalid — clear and bounce to login
      localStorage.removeItem("tcd_token");
      localStorage.removeItem("tcd_token_orig");
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
